import { pathJoin } from 'src/reducers/routing/utils'

export const createAssetManagementRoutesMap = (prefix: string) => ({
  'container-types': pathJoin(prefix)('container-types').chain,
  'waste-fractions': pathJoin(prefix)('waste-fractions').chain,
})
